import template from './loansSignUpFormFields.html';
import controller from './loansSignUpFormFields.controller';
import './loansSignUpFormFields.scss';

let loansSignUpFormFieldsComponent = {
  restrict: 'E',
  bindings: {
    loan: '<',
    simulation: '<',
    backSimulation: '<',
    loanPurposes: '<',
    housingChange: '<',
    housingLoan: '<',
    isVariousCredit: '<',
    onOpenDetail: '&',
    isMobileApp: '<'
  },
  template,
  controller,
};

export default loansSignUpFormFieldsComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansSignUp/loansSignUpForm/loansSignUpFormFields/loansSignUpFormFields.component.js